import React, { useEffect, useState } from 'react'
import Header from '../components/Header/Header'
import ProjectsData from '../components/ProjectsData/ProjectsData'
import PROJECTS_DATA from '../projects.data'

const ProjectDetailspage = (props) => {
    const projectsData = PROJECTS_DATA

    const [selectedProject, setSelectedProjects] = useState(null)

    useEffect(() => {
        const select = projectsData.filter((project) => (project.id === Number(props.match.params.id)))
        setSelectedProjects(select)
    }, [])

    const renderItems = <><Header projectsData={selectedProject} /><ProjectsData projectsData={selectedProject} /></>

    return (
        <>
            {selectedProject ? renderItems : <h1>"Loading..."</h1>}
        </>
    )
}

export default ProjectDetailspage
